'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';

	var setWorksDetail = function setWorksDetail() {
		$('.case-detail-img').owlCarousel({
			items: 1,
			autoplay: false,
			loop: true,
			nav: true,
			navText: '',
			thumbs: true,
			thumbImage: true,
			thumbContainerClass: 'owl-thumbs',
			thumbItemClass: 'owl-thumb-item'
		});
		$('.case_detail').addClass(v);
		$('img').bind('contextmenu', function () {
			return false;
		});
	};
	var fadeInContent = function fadeInContent() {
		$('.js-fadeIn').addClass(v);
	};

	setWorksDetail();
	fadeInContent();
})(window.jQuery, window.FUNCTIONS);